module.exports = __webpack_public_path__ + "img/3.cf833eb0.png";